var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.title},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{class:_vm.$style.subtitle},[_vm._v("\n    "+_vm._s(_vm.paymentId)+"\n  ")]),_vm._t("default"),(_vm.$slots.hasOwnProperty('footer'))?_c('div',{class:_vm.$style.footer},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }